
        require('./index.scss');
        'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

require('module/home-index/header/header-nav');

require('module/home-index/header/header-banner');

require('module/home-index/header/header-links');

require('module/home-index/header/bottom-ads');

require('module/ad/ad-rect-new');

require('module/ad/ad-banner-r');

require('module/home-index/home-toutiao');

require('module/home-index/decoration-cal');

require('module/home-index/design-free');

require('module/home-index/feed');

require('module/home-index/brand-recomd');

require('module/home-detail/right-toolbar');

require('@front-end/common-module-vm/feedback-dialog');

require('@front-end/common-module-vm/shopping-cart');

require('module/home-index/decoration');

require('page/footer.js');

require('module/home-detail/breadcrumbs');

require('module/home-detail/author');

require('module/home-detail/more');

require('module/home-detail/next');

require('module/home-detail/next-and-pre');

require('module/home-detail/friend-link');

require('module/home-detail/hot');

require('module/home-detail/related');

require('module/home-detail/cross-ad');

require('module/home-detail/flanks-ad');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$;

$(document).ready(function () {
    var ua = navigator && navigator.userAgent;
    var btn = $('#follow');
    var followed = btn.attr('data-isFollow');
    var uid = btn.attr('data-uid');
    var author = btn.attr('data-author');
    var links = $('.link a');
    $(window).scroll(function () {
        if ($(window).scrollTop() >= $('.friendly-link').offset().top + $('.friendly-link').height()) {
            $('.related').css('position', 'fixed').css('top', '0px').slideDown('slow');
        } else {
            $('.related').css('position', 'static');
        }
    });
    links.on('click', function () {
        window.sessionStorage.clear();
    });
    var login = function login() {
        console.log(uid);
        document.querySelectorAll('.btn-open-login .txt')[0].click();
    };
    var popup = function popup(string) {
        var pop = $('.popup');
        pop.text(string);
        pop.css('display', 'block');
        setTimeout(function () {
            return pop.css('display', 'none');
        }, 3000);
    };
    var follow = function follow() {
        console.log('process follow:', author);
        // FIXME: appId and domain should be adjusted
        var appId = '50001';
        var domain = 'u.focus.cn';
        fetch && fetch('//' + domain + '/api/v1/follow?&' + new Date().getTime(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': '*/*'
            },
            credentials: 'include',
            body: 'appId=' + appId + '&followUid=' + author
        }).then(function (res) {
            return res.json();
        }).then(function (res) {
            if (res && res.data) {
                if ((0, _values2['default'])(res.data)[0] === true) {
                    console.log('followed!');
                    popup('已关注');
                    btn.remove();
                }
            } else if (res && res.msg) {
                if (res.msg === '用户已关注' || res.msg === '成功') {
                    popup('已关注');
                    btn.remove();
                }
            }
        });
        // $.ajax(`//${domain}/api/v1/follow?&${new Date().getTime()}`, {
        //     method: 'POST',
        //     contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        //     xhrFields: {
        //         withCredentials: true
        //     },
        //     data: `appId=${appId}&followUid=${author}`
        // })
        //     .done(function (res) {
        //         if (res && res.msg) {
        //             if (res.msg === '用户已关注' || res.msg === '成功') {
        //                 popup('已关注');
        //                 btn.remove();
        //             } else {
        //                 popup(res.msg);
        //             }
        //         }
        //     })
    };
    if ($($('.content').children('p').get(0)).attr('class') === 'pi') {
        $($('.content').children('p').get(0)).find('img').css('margin-top', '0');
        $($('.content').children('p').get(0)).find('video').css('margin-top', '0');
    }
    if (ua && /Android|iPhone|iPad/.test(ua)) {
        // TODO: switch to WAP
        console.log('phone:', ua);
    } else {
        console.log('pc:', ua);
    }
    $('.cur').removeClass('cur');
    $('.btn-open-wx').remove();
    $('.btn-open-platform:first').remove();
    if (followed == 'true' || ua.indexOf('Trident') != -1) {
        btn.remove();
    } else {
        if (uid == 0) {
            btn[0].addEventListener('click', login);
        } else {
            btn[0].removeEventListener('click', login);
            btn[0].addEventListener('click', follow);
        }
    }
});;
    


// WEBPACK FOOTER //
// ./src/page/home-detail/index.js